import React, { useState } from 'react';
import {
  ActivityIndicator, ImageBackground, TextInput, View,
} from 'react-native';
import {
  Button, Colors, Dialog, Paragraph, Portal,
} from 'react-native-paper';
import Icon from 'react-native-vector-icons/Ionicons';
import { useSelector } from 'react-redux';

import leths_back from '../../../assets/images/leths_back.png';
import { Header } from '../../../components/common';
import { AppButton } from '../../../components/form';
import { pixelDimensions } from '../../../config/utils';
import { API } from '../../../service/api';
import styles from './styles';

const AlterPassword = ({ navigation }) => {
  const { workerData } = useSelector((state) => state.worker);
  const [pass, setPass] = useState({
    pass: '',
    newPass: '',
  });
  const [visiblePass, setVisiblePass] = useState(false);
  const [visibleNewPass, setVisibleNewPass] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [passOK, setPassOK] = useState(false);
  const [passError, setPassError] = useState(false);

  async function handleAlterPass() {
    setLoading(true);
    try {
      await API.post('/changepwd', {
        email: workerData.email,
        senha_atual: pass.pass,
        nova_senha: pass.newPass,
        perfil: 'COLABORADOR',
      });
      setPassOK(true);
    } catch (err) {
      console.log(err);
      setPassError(true);
    } finally {
      setLoading(false);
    }
  }
  return (
    <>
      <Portal>
        <Dialog visible={passOK} onDismiss={() => setPassOK(false)}>
          <Dialog.Title>Redefinição de senha</Dialog.Title>
          <Dialog.Content>
            <Paragraph>Sua Senha foi alterada</Paragraph>
          </Dialog.Content>
          <Dialog.Actions>
            <Button onPress={() => { setPassOK(false); navigation.goBack(); }}>Ok</Button>
          </Dialog.Actions>
        </Dialog>
      </Portal>
      <Portal>
        <Dialog visible={passError} onDismiss={() => setPassError(false)}>
          <Dialog.Title>Redefinição de senha</Dialog.Title>
          <Dialog.Content>
            <Paragraph>Não foi possível alterar sua senha</Paragraph>
          </Dialog.Content>
          <Dialog.Actions>
            <Button onPress={() => { setPassError(false); }}>Ok</Button>
          </Dialog.Actions>
        </Dialog>
      </Portal>
      <ImageBackground source={leths_back} style={styles.viewBase}>
        <Header navigation={navigation} profilePic={workerData.foto} userName={workerData.nome} />
        <View style={styles.content}>
          <View style={styles.viewForm}>
            <View>
              <TextInput
                value={pass.pass}
                onChangeText={(lastPass) => setPass({ ...pass, pass: lastPass })}
                placeholder="Senha Atual"
                secureTextEntry={!visiblePass}
                style={styles.input}
              />
              <Icon name="settings-outline" style={styles.inputIcon} />
              <Icon
                name={visiblePass ? 'eye-off' : 'eye'}
                onPress={() => setVisiblePass(!visiblePass)}
                style={[styles.inputIcon, styles.inputIconEye]}
              />
            </View>
            <View>
              <TextInput
                value={pass.newPass}
                onChangeText={(newPass) => setPass({ ...pass, newPass })}
                placeholder="Nova Senha"
                secureTextEntry={!visibleNewPass}
                style={styles.input}
              />
              <Icon name="settings-outline" style={styles.inputIcon} />
              <Icon
                name={visiblePass ? 'eye-off' : 'eye'}
                onPress={() => setVisibleNewPass(!visibleNewPass)}
                style={[styles.inputIcon, styles.inputIconEye]}
              />
            </View>
            <AppButton
              size="bold"
              disabled={isLoading || pass.pass === '' || pass.newPass === ''}
              label={isLoading ? <ActivityIndicator color="#FFF" size={pixelDimensions(7)} /> : 'ALTERAR SENHA'}
              labelStyle={styles.textButton}
              onPress={() => !isLoading && handleAlterPass()}
              style={styles.button}
            />
          </View>
          <AppButton size="bold" label="VOLTAR" rippleColor={Colors.indigo700} style={styles.buttonBack} labelStyle={styles.textBack} onPress={() => navigation.goBack()} />
        </View>
      </ImageBackground>
    </>
  );
};

export default AlterPassword;
